import { Search, Sparkles } from "lucide-react";

const RESULTS = [
    { title: "Wireless noise-cancelling headphones", meta: "Audio · 412 in stock", rel: 98, top: true },
    { title: "Over-ear studio monitor headset", meta: "Audio · 96 in stock", rel: 93 },
    { title: "Active noise-cancel earbuds (Gen 3)", meta: "Audio · 1,240 in stock", rel: 89 },
    { title: "Travel headphone case — universal", meta: "Accessories", rel: 71 },
];

/**
 * Reusable enterprise/commerce "AI Search" mockup.
 */
export default function SearchResultsPanel({ className = "" }) {
    return (
        <div
            className={`rounded-2xl bg-white border border-[#303030]/10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.55)] overflow-hidden ${className}`}
            data-testid="mockup-search-results"
            aria-hidden="true"
        >
            <div className="px-4 py-3 border-b border-[#303030]/8 bg-[#FAFAF8]">
                <div className="flex items-center gap-2 rounded-lg bg-white border border-[#303030]/10 px-3 py-2">
                    <Search className="w-3.5 h-3.5 text-[#FF4040]" />
                    <span className="text-[12px] text-[#303030]/80">"comfy headphones for long flights"</span>
                </div>
                <p className="mt-2 text-[10px] text-[#303030]/50 inline-flex items-center gap-1">
                    <Sparkles className="w-3 h-3 text-[#FF4040]" /> semantic intent · noise-cancelling · comfort
                </p>
            </div>

            <ul className="divide-y divide-[#303030]/6">
                {RESULTS.map((r, i) => (
                    <li
                        key={r.title}
                        className={`flex items-center gap-3 px-4 py-2.5 pqx-pop-in ${r.top ? "bg-[#FF4040]/[0.035]" : ""}`}
                        style={{ animationDelay: `${i * 100}ms` }}
                    >
                        <span className="w-8 h-8 rounded-lg bg-[#303030]/8 shrink-0" />
                        <div className="flex-1 min-w-0">
                            <p className="text-[12.5px] font-semibold text-[#303030] truncate leading-tight">{r.title}</p>
                            <p className="text-[10.5px] text-[#303030]/55">{r.meta}</p>
                        </div>
                        <span className="font-mono text-[11px] font-semibold text-[#FF4040] shrink-0">{r.rel}%</span>
                    </li>
                ))}
            </ul>

            <div className="px-4 py-2.5 border-t border-[#303030]/8 flex items-center justify-between bg-[#FAFAF8]">
                <span className="text-[11px] text-[#303030]/60">Zero-result rate ↓ 41%</span>
                <span className="font-mono text-[10px] text-[#303030]/45">personalised ranking</span>
            </div>
        </div>
    );
}
